import React, { Component } from 'react';
import App_data from '../config/App_data';
import FD from '../RestAPI/fetchData';
import moment from 'moment';
import language from '../../assets/languages/language';
import GD from '../RestAPI/getData';
import { _getProfile, renderHTMLContent } from '../../common/function';
/* eslint-disable*/

class OrderHistory extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      readings: [],
      token: '',
      idname: '',
      ValidToken: false,
      selectedMenu: this.props.params.selectedMenu,
      orders_list: '',
      no_restult_display: '',
      startLoaderPage: false,
      username: '',
      China_price: 6.55,
      canadian_price: 5.22,
      usd_canadian_price: 1.26,
    };
  }

  //it is use to redirect page

  static contextTypes = {
    router: React.PropTypes.object,
  };

  _getOrderdiscription = (order, e) => {
    this.context.router.push({
      pathname: `/orderdiscription/${order.id}/${this.state.selectedMenu}/${this.state.username
        }`,
    });
  };

  getChinaPrice = () => {
    GD.GetCallAPI('https://api.exchangeratesapi.io/latest?base=USD').then(
      (resp) => {
        // console.log("resunfnvd", resp);
        // console.log("dollar", resp.rates.CNY);
        this.setState({
          China_price: resp.rates.CNY,
        });
      }
    );
  };

  componentDidMount() {
    // this.getChinaPrice();
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    this.props.params
      ? this.setState({ username: this.props.params.username })
      : null;
    this.setState({ startLoaderPage: true });
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    FD.callAPI(App_data.backend_api + '/checkout_v1/getOrders', data).then(
      (resp) => {
        if (resp.success) {
          // console.log(resp.orders);
          this.setState({ ValidToken: true });
          this.setState({ orders_list: resp.orders });
          this.setState({ startLoaderPage: false });
          if (!resp.orders.length) {
            this.setState({
              no_restult_display: `<td colspan="6" className="" align="center"> ${language.LC().No_Order_History
                } </td>`,
            });
          }
        } else {
          this.setState({ ValidToken: false });
          this.setState({ startLoaderPage: false });
        }
        return resp;
      }
    );
  }

  render() {
    let orders_list = this.state.orders_list;
    let data = '';
    if (this.state.orders_list.length) {
      data = orders_list.map((item, index) => (
        <tr key={index}>
          <td>{item.id}</td>
          <td className='text-capitalize'>{item.payment_type}</td>
          <td className='text-capitalize'>{item.payment_status}</td>{' '}
          <td>
            <Package_fun order_data={item.order_data} />
          </td>
          <td>{moment(item.createdAt).format('llll')}</td>
          <td>
            {item.payment_type !== 'AppSumo' ? (
              <button
                type='button'
                className='btn_circle_sm'
                onClick={this._getOrderdiscription.bind(this, item)}
                id={item.id}
              >
                <i className='fa fa-eye' />
              </button>
            ) : (
              '-'
            )}
          </td>
        </tr>
      ));
    } else {
      data = (
        renderHTMLContent(
          this.state.no_restult_display,
          "tr",
          "",
          { contentEditable: 'false' }
        )
      );
    }

    return (
      <div className='animated fadeIn'>
        {this.state.startLoaderPage ? (
          <div className='loader_box'>
            <div className='sk-circle'>
              <div className='sk-circle1 sk-child' />
              <div className='sk-circle2 sk-child' />
              <div className='sk-circle3 sk-child' />
              <div className='sk-circle4 sk-child' />
              <div className='sk-circle5 sk-child' />
              <div className='sk-circle6 sk-child' />
              <div className='sk-circle7 sk-child' />
              <div className='sk-circle8 sk-child' />
              <div className='sk-circle9 sk-child' />
              <div className='sk-circle10 sk-child' />
              <div className='sk-circle11 sk-child' />
              <div className='sk-circle12 sk-child' />
            </div>
          </div>
        ) : null}
        <div className='card height_70vh'>
          <div className='card-header order-header'>
            <div className='mb-1 d-inline-block'>
              {language.LC().ORDERS_History}
            </div>
            <div className='card-actions float-md-right'>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={_getProfile.bind(this, this.state.username)}
              >
                {language.LC().GO_TO_PROFILE}
              </button>
            </div>
          </div>

          <div id='table_responsive_wrapper'>
            <div className='table-responsive order_his_tb'>
              <table className='cart_table table'>
                <thead>
                  <tr className='border_top_0'>
                    <th>{language.LC().ORDER_ID}</th>
                    <th>{language.LC().PAYMENT_TYPE}</th>
                    <th>{language.LC().PAYMENT_STATUS}</th>
                    <th>{language.LC().PACKAGE}</th>
                    <th>{language.LC().ORDER_DATE}</th>
                    <th>{language.LC().ACTION}</th>
                  </tr>
                </thead>
                <tbody>{data}</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

var returnpackage_val = '';

function Package_fun(props) {
  if (props.order_data) {
    var data = JSON.parse(props.order_data);
    var package_details = data.all_order_details;

    returnpackage_val = package_details.map((item, index) => (
      <div key={index}>
        <li className='package-heading'>
          {item.exam_name + ' - ' + item.package_type}
        </li>
        <div className='order'>
          {item.extras
            ? item.extras.map((extras, index) => (
              <span key={index}>
                <li className='order-extras'>{'- ' + extras.title}</li>
              </span>
            ))
            : ''}
        </div>
      </div>
    ));
  }
  return <span>{returnpackage_val}</span>;
}

export default OrderHistory;



// WEBPACK FOOTER //
// ./src/views/OrderHistory/OrderHistory.js